import React from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import { School as SchoolIcon } from '@mui/icons-material';
import { liveAnalyticsAPI } from '../../services/liveAnalyticsApi';

const DistrictOverview: React.FC = () => {
  const { data: analyticsData, isLoading, error } = useQuery({
    queryKey: ['liveSchoolAnalytics'],
    queryFn: () => liveAnalyticsAPI.getLiveSchoolAnalytics()
  });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <Typography color="error">Failed to load district data</Typography>
      </Box>
    );
  }

  const districts = analyticsData?.data?.by_district || [];

  return (
    <Box sx={{ height: 300, overflow: 'auto' }}>
      <List>
        {districts.map((district: any, index: number) => (
          <ListItem key={index}>
            <ListItemIcon>
              <SchoolIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary={district.district_name}
              secondary={`${district.school_count} schools`}
            />
            <Chip
              label={district.school_count}
              size="small"
              color="primary"
              variant="outlined"
            />
          </ListItem>
        ))}
        {districts.length === 0 && (
          <ListItem>
            <ListItemText
              primary="No data available"
              secondary="No districts found"
            />
          </ListItem>
        )}
      </List>
    </Box>
  );
};

export default DistrictOverview;